import { Pagination } from 'antd';
import { CaretLeftSolid, CaretRightSolid } from '../../utils/icons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStyle from './index.styles';

const PaginationMemorial = ({
  defaultPageSize,
  onChange,
  defaultPage = 1,
  pageSizeOptions,
  totalElements,
}: {
  defaultPageSize: number;
  onChange: ({ page, pageSize }: { page: number; pageSize: number }) => void;
  defaultPage?: number;
  pageSizeOptions?: number[];
  totalElements: number;
}) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(defaultPageSize);
  const { t } = useTranslation();
  const classes = useStyle();

  useEffect(() => {
    setPageSize(defaultPageSize);
    setCurrentPage(defaultPage || 1);
  }, [defaultPage, defaultPageSize]);

  return (
    <div className={classes.container}>
      <Pagination
        itemRender={(page, type) => {
          const commonClass = 'flex h-full items-center justify-center rounded-[8px]';
          const disableIconClass = 'cursor-default bg-bg3 [&>svg>path]:fill-text3';
          if (type === 'prev') {
            const isDisabled = currentPage === 1;
            return (
              <div className={`${commonClass} ${isDisabled ? disableIconClass : 'bg-bg4'}`}>
                <CaretLeftSolid className="w-[8.5px]" />
              </div>
            );
          }
          if (type === 'next') {
            const isDisabled = currentPage >= totalElements / pageSize;
            return (
              <div className={`${commonClass} ${isDisabled ? disableIconClass : 'bg-bg4'}`}>
                <CaretRightSolid className="w-[8.5px]" />
              </div>
            );
          }
          if (type === 'page') {
            return (
              <div className={`${commonClass} ${currentPage === page ? 'bg-bg2' : 'bg-bg4'}`}>
                {page}
              </div>
            );
          }

          return <div className={`${commonClass} bg-bg4`}>...</div>;
        }}
        pageSize={pageSize}
        current={currentPage}
        showSizeChanger={!!pageSizeOptions}
        total={totalElements}
        onChange={(page, pageSize) => {
          setPageSize(pageSize);
          setCurrentPage(page);
          onChange({ page, pageSize });
        }}
        locale={{
          items_per_page: String(t('pagination.itemsPerPage')),
          next_page: String(t('pagination.nextPage')),
          prev_page: String(t('pagination.previousPage')),
          prev_5: String(t('pagination.previous5')),
          next_5: String(t('pagination.next5')),
          prev_3: String(t('pagination.previous3')),
          next_3: String(t('pagination.next3')),
        }}
        pageSizeOptions={pageSizeOptions}
      />
    </div>
  );
};

export default PaginationMemorial;
